import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useAppDispatch } from 'universal-scripts'
import {
  addItem,
  closeItemEditor,
  replaceItem
} from 'src/store/slices/dashboard'
import type { AllowedColSpan } from 'src/types/dashboard'

interface LabelFormProps {
  initial: { title: string; text: string }
  itemId: string | null
  existingWidth?: AllowedColSpan
}

export default function LabelForm({
  initial,
  itemId,
  existingWidth
}: LabelFormProps) {
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const [title, setTitle] = useState(initial.title)
  const [text, setText] = useState(initial.text)

  const isValid = title.trim() !== '' || text.trim() !== ''

  const handleApply = () => {
    if (!isValid) return

    const width: AllowedColSpan = existingWidth ?? 3

    if (itemId) {
      dispatch(
        replaceItem({
          itemId,
          item: {
            itemId,
            type: 'label',
            width,
            title: title.trim(),
            text: text.trim()
          }
        })
      )
    } else {
      dispatch(
        addItem({
          itemId: crypto.randomUUID(),
          type: 'label',
          width,
          title: title.trim(),
          text: text.trim()
        })
      )
    }

    dispatch(closeItemEditor())
  }

  const handleCancel = () => dispatch(closeItemEditor())

  return (
    <aside id="item-editor-panel">
      <header className="item-editor-header">
        <h3>
          <FormattedMessage id="item-editor.chart.editor-title" />
        </h3>
        <div className="item-editor-actions">
          <button
            className="highlight-button"
            onClick={handleApply}
            disabled={!isValid}
          >
            <span>
              <FormattedMessage id="node-editor.button.apply" />
            </span>
          </button>
          <span
            className="icon icon-cross standart-button"
            onClick={handleCancel}
          />
        </div>
      </header>
      <div className="item-editor-body">
        <label>
          <h4>
            <FormattedMessage id="item-editor.label.title" />
          </h4>
          <input
            type="text"
            autoFocus
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder={intl.formatMessage({
              id: 'item-editor.label.title.placeholder'
            })}
          />
        </label>
        <label>
          <h4>
            <FormattedMessage id="item-editor.label.text" />
          </h4>
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder={intl.formatMessage({
              id: 'item-editor.label.text.placeholder'
            })}
          />
        </label>
      </div>
    </aside>
  )
}
